<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table
  height 180px
  margin 0 auto
  padding 15px 10px
  color #fff
  text-align center
  overflow hidden
  .main
    width 100%
    height 100%
    .list-item{
      &:nth-child(even){
        background: #123EB5
      }
      height: 50px;
      line-height: 50px;
      display: flex;
      .item:nth-child(1){
        width: 20%;
      }
      .item:nth-child(2){
        width: 20%;
      }
      .item:nth-child(3){
        width: 20%;
      }
      .item:nth-child(4){
        width: 20%;
      }
      .item:nth-child(5){
        width: 20%;
      }
    }
    .list-item1{
      background: #1A5CD1;
      color: #00FEFB;
    }
    // table
    //   width 100%
    //   margin-top 4px
    //   text-align center
    //   .tr
    //     &:nth-child(even)
    //       background  #123EB5
    //   .theader
    //     background: rgba(8,26,84,0);
    //     border: 1px solid rgba(0,96,255,1);
    //     box-shadow: inset 5px 10px 10px 0px rgba(0,96,255,0.5);
    //   tr
    //     height 30px
    //     line-height 30px
    //     th
    //       width 20%
    //       color #77CAD8
    //     td
    //       width 20%

</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <div class="main">
        <div class="list-item list-item1">
          <div class="item">品种</div>
          <div class="item">生产规模</div>
          <div class="item">产值/亿元</div>
          <div class="item">产量/吨</div>
          <div class="item">上市周期</div>
        </div>
        <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="tableData.length!=0">
          <swiper-slide v-for="(item,index) in tableData" :key="index" class="list-item"> 
            <div class="item">{{item.name}}</div>
            <div class="item">{{item.scale}}</div>
            <div class="item">{{item.output}}</div>
            <div class="item">{{item.production}}</div>
            <div class="item">{{item.listed}}</div>
          </swiper-slide>
        </swiper>
        <!-- <table>
          <tr class="theader">
            <th>种类</th>
            <th>生产规模</th>
            <th>产值</th>
            <th>产量</th>
            <th>上市周期</th>
          </tr>
          <tr v-for="(item, index) in tableData" :key="index" class="tr">
            <td>{{item.name}}</td>
            <td>{{item.scale}}</td>
            <td>{{item.output}}</td>
            <td>{{item.production}}</td>
            <td>{{item.listed}}</td>
          </tr>
        </table> -->
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '支柱产业市场分析',
      tableData: [
        {name: '田阳香芒', scale: '39.7万亩', output: '11.3', production: '236000', listed: '夏季'},
        {name: '百色番茄', scale: '19万亩', output: '14', production: '550000', listed: '夏季'},
        {name: '蔬菜', scale: '15万亩', output: '9', production: '164000', listed: '全年'}
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {

  }
}

</script>



// WEBPACK FOOTER //
// index.vue?11469ec7